import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

export function useRouteGuard(allow: boolean, to: string) {
  const navigate = useNavigate()

  useEffect(() => {
    if (!allow) {
      navigate(to, { replace: true })
    }
  }, [allow, to, navigate])
}
